import { ListItemOption } from "@theorgchartdev/storybook/dist/components/List/ListItem";
import { appstr } from "@coreapp/utils/appstr";
import { PillProps } from "@theorgchartdev/storybook/dist/components/Pill/Pill";

export const planObjectiveHelpLink =
  "https://theorgchart.zendesk.com/hc/en-us/articles/35749628429332-Plan-Objectives";

export enum PlanObjectives {
  costReduction = "Cost reduction",
  headcountReduction = "Headcount reduction",
  relocation = "Relocation",
  generalOrgDesign = "General organization design"
}

export const PlanObjectiveColors: Record<string, PillProps["color"]> = {
  [PlanObjectives.costReduction]: "info",
  [PlanObjectives.headcountReduction]: "success",
  [PlanObjectives.relocation]: "warning",
  [PlanObjectives.generalOrgDesign]: "neutral"
};
export const DefaultPlanObjective = PlanObjectives.generalOrgDesign;

export class ObjectiveHandler {
  static buildObjectiveOptions(callback: (objective: ListItemOption) => void): ListItemOption[] {
    return Object.values(PlanObjectives).map((objective, index) => {
      return {
        label: appstr(objective),
        value: objective,
        clickHandler: callback,
        divider: index === 2,
        dataTestId: `ocn-plan-objective-${objective}`
      };
    });
  }
}
